import React from 'react';
import { Link } from 'gatsby';

import activities from '@data/navigation.json';
import logo from '@images/footer-logo.svg';

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <Link to="/">
            <img className="footer__logo" src={logo} alt="Keso-Promet logo" />
          </Link>
          <p className="copyright-text">
            © Copyright {new Date().getFullYear()} Keso-Promet d.o.o.
            <br />
            Sva prava zadržana.
          </p>
        </div>

        <div className="col-md-2 d-none d-md-block">
          <p className='h6'><strong>Kompanija</strong></p>
          <ul className="list-group list-group-flush">
            <li>
              <Link to="/" className="list-group-item list-group-item-action">
                Početna
              </Link>
            </li>
            <li>
              <Link to="/#about" className="list-group-item list-group-item-action">
                O nama
              </Link>
            </li>
            <li>
              <Link to="/#contact" className="list-group-item list-group-item-action">
                Kontakt
              </Link>
            </li>
          </ul>
        </div>
        <div className="col-md-4 d-none d-md-block">
          <p className='h6'><strong>Djelatnosti</strong></p>
          <ul className="list-group list-group-flush">
            {activities.map(item => (
              <li key={item.to}>
                <Link to={item.to} className="list-group-item list-group-item-action">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
